import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=8c59e4fe"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "./Update.vue?vue&type=style&index=0&id=8c59e4fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports